module.exports = "<p>\n  time-roll-apprve-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Attendance-Leaves/time-roll-approval/time-roll-apprve-form/time-roll-apprve-form.component.html
// module id = ./src/app/hrms/Attendance-Leaves/time-roll-approval/time-roll-apprve-form/time-roll-apprve-form.component.html
// module chunks = main